import { Box, Button, ColumnConfig, DataTable, Form, FormField, Layer, Spinner, Text, TextInput } from "grommet";
import { Observer, observer } from "mobx-react";
import React, { useEffect, useMemo, useState } from "react";
import { toJS } from "mobx";
import roleEditIcon from "../../../../../../assets/edit.png"

import CreateRolesBarCloser from "../../../../../../assets/close_small.svg";
// import "./RightSideBar.css"

// import       "./DisableRightSideBar.css"
import { useStore } from "../../../../../../Hooks/useStore";
import { AxiosError } from "axios";
import rolesService from "./roles.service";
import { RoleType } from "./types/RoleType";
import { Mixpanel } from "../../../../../../util/Helper";
import { PermissionType } from "../Permissions/types/PermissionType";
import { useLocation, useNavigate } from "react-router-dom";
import "./CreateRolesBar.css";
import { UserType } from "../Users/types/UserType";
import { EditRoleStore } from "../../../../../../store/EditRoleStore";

interface EditRolesProps {
    user: UserType;
  }
  
  function EditRolesBar() {
    const navigate = useNavigate();

    const fromRole = useLocation().state as RoleType;

    const [inputValue, setInputValue] = useState('');
    

    // const handleInputChange = (event) => {
    //   setInputValue(event.target.value);
    // };
    const handleSubmit = () => {
      
      console.log('Form submitted with value:', inputValue);

    };

   
  
const {rootStore}=useStore();
// const handleUserShowDisableConfirmation = () => {
//   this.userShowDisableConfirmation = newVal;
// }
useEffect(() => {
  if (fromRole !== null) {
    rootStore.adminStore.handleSelectedPermission(
      fromRole.permissions.map((permission) => permission.code)
    );
  }
}, [fromRole]);

const columns = useMemo(() => {
  return [
    {
      property: "code",
      header: "Permission Code",
      primary: true,
      render: (item) => {
        return <div className="user-cell-container">{item.code}</div>;
      },
    },
    {
      property: "description",
      header: "Description",
      primary: true,
      render: (item) => {
        
        return <div className="user-cell-container">{item.description}</div>;
    
      },
    },
  ] as ColumnConfig<PermissionType>[];
}, []);
// const EditRoles: React.FC<EditRolesProps> = ({ user }) => {


//   return(
//       <div className="cell-container">
//               <img src={roleEditIcon} alt="" />
//             </div>
//   )
// }

interface EditRolesProps {
  user: UserType;
  code:String;
  displayName:String;
}

const EditRoles: React.FC<EditRolesProps> = ({ user }) => {
  return (
    <div className="cell-container">
      <img src={roleEditIcon} alt="" />
    </div>
  );
}

return(

    <Layer className="create-role-sidebar-container"
    style={{borderRadius: "12px 0px 0px 0px",width:"700px", height:"100%"}}
    full="vertical"
    position="right"
    onEsc={() => {
      rootStore.adminStore.handleEditRoles(false)
   
    }
  }
    >
     <Box
        fill
        style={{ minWidth: "378px",borderRadius: "12px 0px 0px 0px", maxWidth: "700px" }}
        flex
        flex-start
        direction="column"
        
        align="center"
      >
         <Box
        style={{borderRadius: "12px 0px 0px 0px", display:"flex",flexDirection:"row",justifyContent:"space-between"
        }}
          direction="column"
   
          as="header"
     
          background={"#E9F2FF"}
          width="100%"
          pad={"small"}
          
        >
            <Text
            style={{
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px"
            }}>Edit Role</Text>
            {/* <Button 
        style={{color: "#357EFF",
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "16px"}} onClick={() => {
            Mixpanel.track("web close " );
            onCancel();
          }} ><img src={closeActionSidebar} style={{width: 20, height: 20}}/>Close</Button> */}
                <Button
                 style={{color: "#357EFF",
                 fontFamily: "Inter",
                 fontSize: "14px",
                 fontStyle: "normal",
                 fontWeight: "600",
                 lineHeight: "16px"}} onClick={() => {rootStore.adminStore.handleEditRoles(false);
                 }}><img src={CreateRolesBarCloser} style={{width: 20, height: 20}}/>
                 Close</Button>
         
        </Box>
        <Box className="create-Roles-middle-container">
         <Form
         style={{width:"700px", padding:"20px"}}
          validate="change"
          onSubmit={({ value }: { value: any }) => {
            let uInfos = localStorage.getItem("userinfo");
            if (uInfos) {
            const userinformation = JSON.parse(uInfos);
            Mixpanel.track("web_create_role_submit_click",{name: userinformation?.username});
            }
            const { code, displayName } = value;
            if (rootStore.adminStore.getSelectedPermission.length == 0) {
              rootStore.adminStore.handleValidationError("Please select atleast 1 permission!");
            } else {
              //TODO api call
              const new_role: RoleType = {
                code,
                displayName,
                permissions: [],
                isStandard: false,
              };
  
              rolesService
                .createRole(new_role)
                .then(async (res) => {
                  const assignmentRequests = Promise.all(
                    rootStore.adminStore.getSelectedPermission.map((permissionCode) =>
                      rolesService.assignPermission(
                        new_role.code,
                        permissionCode as string
                        
                      )
                    )
                  );
                  try {
                    await assignmentRequests;
                    alert("Role created!");
                  } catch (e) {
                    if (e instanceof AxiosError) {
                      rootStore.errorHandlingStore.displayError(e.message);
                    } else {
                      rootStore.errorHandlingStore.displayError(
                        "Error occured while assigning permissions to the role: " +
                          new_role.code
                      );
                    }
                  }
                })
                .catch((error: AxiosError) => {
                  rootStore.errorHandlingStore.displayError(error.message);
                });
            }
          }}
          className="create-Role-Form"
         >
         <FormField
         className="create-Role-Form-F1"
          name="code"
          htmlFor="textinput-id"
          required
          validate={[
            {
              regexp: /^[a-zA-Z0-9]+(-+[a-zA-Z0-9]+)*$/,
              message:
                "These characters can be used: a-z A-Z 0-9 - (must start and end with letters or numbers)",
            },
          ]}
        >
          <label 
           style={{
            color: "#4B628A",
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "22px",
  alignSelf: "stretch"
           }}
          className="Create-Role-Form-L1">Role Name</label>
          <TextInput style={{
            display: "flex",
            padding: "13px 15px",
            alignItems: "flex-start",
            gap: "10px",
            alignSelf: "stretch",
            borderRadius: "10px",
background: "#F2F8FF",
color: "#41454B",
fontFamily: "Inter",
fontSize: "14px",
fontStyle: "normal",
fontWeight: "500",
lineHeight: "22px"/* 157.143% */
          }} className="Create-Role-Form-I1"  name="code" placeholder="Role Name"/>
        </FormField>
        <FormField className="Create-Role-Form-F2" name="displayName" htmlFor="textinput-id" required>
          <label 
           style={{
            color: "#4B628A",
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "22px",
  alignSelf: "stretch"
           }}
          className="Create-Role-Form-L1">Description</label>
          <TextInput
          style={{
            display: "flex",
            padding: "13px 15px",
            alignItems: "flex-start",
            gap: "10px",
            alignSelf: "stretch",
            borderRadius: "10px",
background: "#F2F8FF",
height:"80px",
borderBottom:"none",
color: "#41454B",
fontFamily: "Inter",
fontSize: "14px",
fontStyle: "normal",
fontWeight: "500",
lineHeight: "22px" /* 157.143% */

          }}
          className="Create-Role-Form-I2"
            id="textinput-id"
            name="displayName"
            placeholder="Enter Here"


          />
        </FormField>
        <DataTable
            id="table-id"
            className="user-list-table-container"
            columns={columns}
            data={rootStore.adminStore.getPermissions}
            resizeable
            step={5}
            sortable
            title="Permissions"
            onSelect={(items) => {
              if (items.length > 0) {
                rootStore.adminStore.handleValidationError("");
              }
              rootStore.adminStore.handleSelectedPermission(items);
            }}
            select={rootStore.adminStore.getSelectedPermission}
            paginate
          />
          {rootStore.adminStore.getPermissions.length == 0 ? (
            <div className="spinner-container">
              <Spinner
                border={[
                  { side: "all", color: "transparent", size: "medium" },
                  { side: "horizontal", color: "brand", size: "medium" },
                ]}
              />
            </div>
          ) : (
            <></>
          )}
        {rootStore.adminStore.getValidationError !== "" ? (
          <p className="validation-text">{rootStore.adminStore.getValidationError}</p>
        ) : (
          <></>
        )}
        <Box style={{
          display:"flex", flexDirection:"row", gap:"10px",
          width:"660px" , justifyContent:"flex-end", paddingTop:"12px"
        }}>
          {/* <Button
            type="button"
            label="Back"
            color={"brand-1"}
            onClick={() => {
              Mixpanel.track("web_create_role_back_click");
              Navigate(-1);
            }}
          /> */}
          <Button
          style={{
            display: "flex",
padding: "14px 49px",
justifyContent: "center",
alignItems: "center",
gap: "10px",
borderRadius: "10px",
border: "1px solid #357EFF",
background: "#FFF",
color: "#357EFF",

fontFamily: "Inter",
fontSize: "16px",
fontStyle: "normal",
fontWeight: "600",
lineHeight: "24px",
          }} type="reset" onClick={() => {
            let uInfos = localStorage.getItem("userinfo");
            if (uInfos) {
            const userinformation = JSON.parse(uInfos);
            Mixpanel.track("web_create_role_reset_click",{name: userinformation?.username});
            }
            rootStore.adminStore.resetSelectedPermission();
            }} label="Reset"  />
          <Button 
          style={{
            display: "flex",
padding: "14px 49px",
justifyContent: "center",
alignItems: "center",
gap: "10px",
borderRadius: "10px",
background: "#357EFF",
color: "var(--all-colors-white-color-white, #FFF)",
fontFamily: "Inter",
fontSize: "16px",
fontStyle: "normal",
fontWeight: "600",
lineHeight: "24px",
          }}
          type="submit" label="Submit"  />
          </Box>
         </Form>
        {/* <Box className="disable-user-btn">
          <Button style={{
            color: "#357EFF",
            display: "flex",
            width: "120px",
            padding: "14px 49px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "10px",
            border: "1px solid #357EFF",
            background: "#FFF",

          }}
          onClick={() => {Mixpanel.track("web_disable_user_cancel_click");
          rootStore.adminStore.handleUserShowDisableConfirmation(false);}}
          label="Cencel"
          />
           <Button 
          label="Confirm"
          
          className={`myButton ${inputValue === 'DISABLE' ? 'active' : 'disabled'}`}
          onClick={async() =>{
            Mixpanel.track("web_disable_user_submit_click");
          try {
            await usersService.disableUsers(rootStore.adminStore.getSelectedusers);
          } catch (e) {
            if (e) {
              rootStore.errorHandlingStore.displayError(e.message);
            } else {
              rootStore.errorHandlingStore.displayError("Error occured while disabling users.");
            }
          }
          }} disabled={inputValue==="DISABLE" ? false : true}
          
          />
        </Box> */}
        </Box>
      </Box>
      </Layer>
    )
    
  }
  
  export default observer(EditRolesBar);
  